<template>
  <div class="login-page" data-test="login__page">
    <Card classNames="login-card">
      <div class="login-card__header">
        <span class="login-title">{{ $t('authPage.title') }}</span>
        <ADAuthForm @loginAttempt="loginAttempt($event)"></ADAuthForm>
      </div>
    </Card>
  </div>
</template>

<script>
  import services from 'services';
  import ADAuthForm from './ADAuthForm.vue';
  import Card from '../../../components/Card/Card.vue';

  export default {
    components: {
      ADAuthForm,
      Card,
    },
    data() {
      return {
        loader: Boolean,
      };
    },
    methods: {
      async loginAttempt(credentials) {
        await services.ADService.loginWithADCredentials(credentials)
          .then((isAuthenticated) => {
            this.loader = true;
            setTimeout(() => (isAuthenticated ? this.$router.push({
                name: 'MgmtShopAuth',
                query: { email: credentials.email },
              })
              : this.failedAuthAttempt()), 2000);
          });
      },
      failedAuthAttempt() {
        this.loader = false;
        this.$message({
          type: 'error',
          message: this.$t('commons.defaultErrorMessage'),
        });
      },
    },
  };
</script>

<style lang="stylus">
  .login-page {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .login-card {
    width: 700px;
    padding: 50px 32px;
  }

  .login-card__header {
    text-align: center;
  }

  .login-title {
    color: #2a8eec;
    position: relative;
    font-size: 2.3em;
    font-weight: 600;
    text-align: center;
    display: inline;
  }
</style>
